var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Check, Circle, Close, Human } from '@hn-ui/icons';
import { Tooltip } from '@hn-ui/tooltips';
var config = {
    not_started: {
        icon: _jsx(Circle, { color: 'black80' }, void 0),
        tooltip: 'Not started',
    },
    in_progress: {
        icon: _jsx(Human, { color: 'black80' }, void 0),
        tooltip: 'In progress',
        tooltipIntervention: 'Need intervention',
    },
    canceled: {
        icon: _jsx(Close, { color: 'red50' }, void 0),
        tooltip: 'Canceled due to difficulty',
    },
    canceled_by_card: {
        icon: _jsx(Close, { color: 'red50' }, void 0),
        tooltip: 'Canceled for tech update',
    },
    canceled_by_teacher: {
        icon: _jsx(Close, { color: 'red50' }, void 0),
        tooltip: 'Canceled by teacher',
    },
    canceled_by_time: {
        icon: _jsx(Close, { color: 'red50' }, void 0),
        tooltip: 'Canceled due to difficulty',
    },
    completed: {
        icon: _jsx(Check, {}, void 0),
        tooltip: 'Completed',
        tooltipIntervention: 'Need intervention',
    },
    expired: { icon: _jsx(Close, { color: 'red50' }, void 0), tooltip: 'Expired' },
};
var Container = styled.li.withConfig({ displayName: "Container", componentId: "sc-10yy0nc" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  margin: 0;\n  padding: 0;\n"], ["\n  display: flex;\n  margin: 0;\n  padding: 0;\n"])));
var InterventionCircle = styled.span.withConfig({ displayName: "InterventionCircle", componentId: "sc-fzacxt" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  background: ", ";\n  transform: translateY(4px);\n"], ["\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  background: ", ";\n  transform: translateY(4px);\n"])), function (_a) {
    var theme = _a.theme, $show = _a.$show;
    return $show ? theme.colors.red40 : 'transparent';
});
var CardStatus = function (_a) {
    var item = _a.item, rest = __rest(_a, ["item"]);
    var _b = config[item.status], icon = _b.icon, tooltip = _b.tooltip, tooltipIntervention = _b.tooltipIntervention;
    var statusHasIntervention = !!tooltipIntervention;
    var showIntervention = item.intervention && statusHasIntervention;
    var tooltipContent = showIntervention ? tooltipIntervention : tooltip;
    return (_jsx(Tooltip, __assign({ content: tooltipContent, maxWidth: '100%' }, { children: _jsxs(Container, __assign({}, rest, { children: [icon, _jsx(InterventionCircle, { "$show": showIntervention }, void 0)] }), void 0) }), void 0));
};
export { CardStatus };
var templateObject_1, templateObject_2;
